import { Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Routes as router } from "../routes"; // Ensure your routes are properly imported
import Cookies from "universal-cookie";

// Pages
// import Presentation from "./Presentation";
// import Upgrade from "./Upgrade";
import DashboardOverview from "./admin/dashboard/dashboard";
import dashboard from "./Superadmin/dashboard/dashboard";
import User from "./admin/User/User";
import Product from "./admin/Product/Product";
import Agencies from "./Superadmin/Agencies/Agencies";
import Tags from "./admin/Tags/Tags";
import Login from "./auth/Login";
import userslist from "./Superadmin/Agencies/UsersList";
import Categories from "./admin/Product/Categories";
import ProductAttributes from "./admin/Product/ProductAttributes";

// Components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Preloader from "../components/Preloader";

import Accordion from "../components/AccordionComponent";
import ValidateAuth from "../components/Authwrapper/ValidateAuth";

// import Accordion from "./components/Accordion";
// import Alerts from "./components/Alerts";
// import Badges from "./components/Badges";
// import Breadcrumbs from "./components/Breadcrumbs";
// import Buttons from "./components/Buttons";
// import Forms from "./components/Forms";
// import Modals from "./components/Modals";
// import Navs from "./components/Navs";
// import Navbars from "./components/Navbars";
// import Pagination from "./components/Pagination";
// import Popovers from "./components/Popovers";
// import Progress from "./components/Progress";
// import Tables from "./components/Tables";
// import Tabs from "./components/Tabs";
// import Tooltips from "./components/Tooltips";
// import Toasts from "./components/Toasts";

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000); // Simulate loading delay
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader show={!loaded} /> {/* Show loader until loaded is true */}
      <Component {...rest} />
    </>
  );
};

// RouteWithSidebar component for managing Sidebar and Navbar layout
const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000); // Simulate loading delay
    return () => clearTimeout(timer);
  }, []);

  // Manage settings visibility based on localStorage
  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(
    localStorageIsSettingsVisible
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <>
      <Preloader show={!loaded} /> {/* Show loader until loaded is true */}
      <Sidebar />
      <main className="content">
        <ValidateAuth>
          <Navbar />
          <Component {...rest} />
          {/* <Footer toggleSettings={toggleSettings} showSettings={showSettings} /> */}
        </ValidateAuth>
      </main>
    </>
  );
};

export default function App() {
  const navigate = useNavigate();
  const cookies = new Cookies(null, { path: "/" });

  const token = cookies.get("zk-vg");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);
  
  return (
    <Routes>
      {/* Routes with Sidebar */}
      <Route
        path={router.admin.Dashboard.path}
        element={<RouteWithSidebar component={DashboardOverview} />}
      />
      <Route
        path={router.superAdmin.Dashboard.path}
        element={<RouteWithSidebar component={dashboard} />}
      />
      <Route
        path={router.superAdmin.Agencies.path}
        element={<RouteWithSidebar component={Agencies} />}
      />
      <Route
        path={router.admin.User.path}
        element={<RouteWithSidebar component={User} />}
      />
      <Route
        path={router.admin.Tags.path}
        element={<RouteWithSidebar component={Tags} />}
      />
      <Route
        path={router.admin.Product.path}
        element={<RouteWithSidebar component={Product} />}
      />
      <Route
        path={router.superAdmin.UserList.path}
        element={<RouteWithSidebar component={userslist} />}
      />
      <Route
        path={router.admin.Categories.path}
        element={<RouteWithSidebar component={Categories} />}
      />
      <Route
        path={router.admin.ProductAttributes.path}
        element={<RouteWithSidebar component={ProductAttributes} />}
      />
      <Route
        path={router.Login.path}
        element={<RouteWithLoader component={Login} />}
      />
    </Routes>
  );
}
